const usingServiceAdvantage = {
  en: {
    title: 'More Speed, More Profit With the Best Cafe POS System',
    desc: 'Save seconds off every order with integrated tools that work together.',
    items: [
      {
        title: 'Easy to start, use and grow with',
        image: `${process.env.ASSETS_PREFIX}/businesstype/busy-cafe-in-the-city.jpg`,
        items: [
          {
            desc: 'Intuitively designed screens for quick order entry and modifications.',
          },
          {
            desc: `Know your bestsellers with daily reporting and tailor your menus to your guests' favorite items.`,
          },
        ],
      },
      {
        title: 'Cut wait-times with tech',
        image: `${process.env.ASSETS_PREFIX}/businesstype/smiling-barista-making-an-order.jpg`,
        items: [
          {
            desc: 'Minimize the wait by letting guests order ahead or on their own via kiosks, online ordering or QR codes.',
          },
          {
            desc: 'Self-service generates higher order volume, higher table turn over, and happier customers.',
          },
          {
            desc: 'Increase speed, order accuracy, and the overall guest experience.',
          },
        ],
      },
      {
        title: 'More Speed, More Profits',
        image: `${process.env.ASSETS_PREFIX}/businesstype/bar-guests-cheering.jpg`,
        items: [
          {
            desc: 'Cafes, bakeries, and other quick service restaurants can save up to $8,000/month.',
          },
          {
            desc: 'Chowbus POS cuts repetitive tasks, boosts sales volume, tips, team productivity, and your profits!',
          },
        ],
      },
    ],
  },

  zh: {
    title: '为餐厅和顾客提供快捷高效的体验',
    desc: '使用Chowbus POS，缩短出餐时间至几十秒',
    items: [
      {
        title: '提升顾客点单效率',
        image: `${process.env.ASSETS_PREFIX}/businesstype/busy-cafe-in-the-city.jpg`,
        items: [
          {
            desc: '到店的顾客可以使用智能自助点餐机等自助下单，减少等待点餐的时间',
          },
          {
            desc: '顾客还可以用网页随时随地地下单、支付，收到餐品完成的短信后，到店立即可取',
          },
        ],
      },

      {
        title: '降低餐厅服务难度',
        image: `${process.env.ASSETS_PREFIX}/businesstype/smiling-barista-making-an-order.jpg`,
        items: [
          {
            desc: '无论是店内自助点餐还是线上订单，顾客自助点餐、支付，减少人力成本',
          },
          {
            desc: '订单直达后厨，无需人工传达订单，店员可以专注在餐品制作，提升出餐速度',
          },
          {
            desc: '集成第三方外卖平台，所有外卖订单直达厨房，无需额外的人力投入',
          },
        ],
      },
      {
        title: '升级餐厅管理体验',
        image: `${process.env.ASSETS_PREFIX}/businesstype/bbarista-making-a-latte.jpg`,
        items: [
          {
            desc: '餐厅可以一站式管理各个点餐渠道的菜单、价格，降低维护投入',
          },
          {
            desc: '通过每日数据概览，随时随地了解营业额、营业额来源及成本数据',
          },
        ],
      },
    ],
  },
};

export default usingServiceAdvantage;
